import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/app-sidebar';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AppHeader } from '@/components/layout/AppHeader';
import { Toaster } from '@/components/ui/sonner';
import { isAuthenticated } from '@/lib/auth/session';

export const Route = createFileRoute('/admin')({
  component: AdminLayout,
  beforeLoad: ({ location }) => {
    // Authenticated while either token is still valid — an expired access token
    // alone doesn't lock you out, since the API client can refresh it.
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
});

function AdminLayout() {
  return (
    <ProtectedRoute>
      <SidebarProvider>
        <div className="flex min-h-screen w-full">
          <AppSidebar />
          {/* min-w-0 lets this column shrink below its content's intrinsic width
              (flex items default to min-width:auto) so wide children — e.g. the
              jobs table — scroll inside their own container instead of pushing
              the whole page horizontally under the sidebar. */}
          <div className="flex min-w-0 flex-1 flex-col">
            <AppHeader />
            <main className="flex-1 overflow-auto">
              <Outlet />
            </main>
          </div>
        </div>
        <Toaster />
      </SidebarProvider>
    </ProtectedRoute>
  );
}
